import React from 'react';
import Link from 'gatsby-link';
import Logo from '../static/img/Hulpia.png';
import styled from 'styled-components';

const HeaderStyled = styled.section`
  border-bottom: 1px solid #000;
`;

const LogoImage = styled.img`
  width: 200px;
`;

const Header = () => (
  <HeaderStyled>
    <Link to="/">
      <LogoImage src={Logo} alt="logo" />
    </Link>
  </HeaderStyled>
);

export default Header;



// WEBPACK FOOTER //
// ./src/componenten/Header.js